// The original Home/FedCrim blog (a hard-coded insightsData list) linked posts
// as /blog-post/<id> and /blog-post/<n>. Each of those six posts now lives in
// content/blog/ under a new slug; keep the old links landing on the article.
const LEGACY_BLOG_POSTS = [
  ["pro-se-file-federal-lawsuit", "How-to-File-a-Self-Represented-Federal-Lawsuit"],
  ["frcp-beginners-guide", "Federal-Civil-Procedure-Explained"],
  ["pro-se-federal-mistakes", "Top-10-Common-Mistakes-Pro-Se-Litigants-Make"],
  ["federal-court-jurisdiction-basics", "Understanding-Federal-Court-Jurisdiction"],
  ["federal-employment-discrimination-lawsuit", "How-to-File-a-Federal-Employment-Discrimination-Suit"],
  ["fix-credit-report-errors-fcra", "How-to-Fix-Credit-Report-Errors-(FCRA)"],
];

export const LEGACY_BLOG_POST_REDIRECTS = LEGACY_BLOG_POSTS.flatMap(([id, slug], index) => [
  [`/blog-post/${id}`, slug],
  [`/blog-post/${index + 1}`, slug],
]);
